// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__EgpzM {
  height: 100%;
  background: var(--tables-main-surface);
}

.trackersArrow__QoSk8 {
  transform: rotate(90deg);
  margin-left: 5px;
  fill: none;
  transition: all 0.3s ease-in-out;
}
.trackersArrow__QoSk8 path {
  stroke: var(--buttons-text-secondary);
}

.trackersArrowTop___hyqX {
  transform: rotate(-90deg);
}

.mainContent__qlANY {
  height: calc(100% - 55px);
  padding: 25px;
  display: grid;
  grid-template-columns: 500px auto;
  grid-template-rows: 112px auto;
  gap: 25px;
}
@media (max-width: 1100px) {
  .mainContent__qlANY {
    padding: 15px;
    grid-template-columns: 400px auto;
    column-gap: 15px;
  }
}
@media (max-width: 950px) {
  .mainContent__qlANY {
    grid-template-columns: 350px auto;
  }
}

.mapWrapper__VU5Pw {
  grid-area: 2/2/3/3;
}`, "",{"version":3,"sources":["webpack://./../src/pages/GPSAssetTracking/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,sCAAA;AAzEF;;AA4EA;EACE,wBAAA;EACA,gBAAA;EACA,UAAA;EACA,gCAAA;AAzEF;AA0EE;EACE,qCAAA;AAxEJ;;AA4EA;EACE,yBAAA;AAzEF;;AA4EA;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,iCAAA;EACA,8BAAA;EACA,SAAA;AAzEF;AA2EE;EARF;IASI,aAAA;IACA,iCAAA;IACA,gBAAA;EAxEF;AACF;AAyEE;EAbF;IAcI,iCAAA;EAtEF;AACF;;AAyEA;EACE,kBAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.page {\n  height: 100%;\n  background: var(--tables-main-surface);\n}\n\n.trackersArrow {\n  transform: rotate(90deg);\n  margin-left: 5px;\n  fill: none;\n  transition: all 0.3s ease-in-out;\n  path {\n    stroke: var(--buttons-text-secondary);\n  }\n}\n\n.trackersArrowTop {\n  transform: rotate(-90deg);\n}\n\n.mainContent {\n  height: calc(100% - 55px);\n  padding: 25px;\n  display: grid;\n  grid-template-columns: 500px auto;\n  grid-template-rows: 112px auto;\n  gap: 25px;\n\n  @media (max-width: 1100px) {\n    padding: 15px;\n    grid-template-columns: 400px auto;\n    column-gap: 15px;\n  }\n  @media (max-width: 950px) {\n    grid-template-columns: 350px auto;\n  }\n}\n\n.mapWrapper {\n  grid-area: 2 / 2 / 3 / 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__EgpzM`,
	"trackersArrow": `trackersArrow__QoSk8`,
	"trackersArrowTop": `trackersArrowTop___hyqX`,
	"mainContent": `mainContent__qlANY`,
	"mapWrapper": `mapWrapper__VU5Pw`
};
module.exports = ___CSS_LOADER_EXPORT___;
